import { Torch } from "@/pages/caster/torches-data-entry/models/torches.models";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ValueGetterParams } from "ag-grid-enterprise";

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Torches",
      children: [
        {
          field: "Strand",
          headerName: "Strand",
          flex: 2,
          minWidth: 60,
        },
        {
          field: "MoldNameAndSize",
          headerName: "Mold",
          flex: 2,
          minWidth: 90,
        },
        {
          field: "ColdLength",
          headerName: "Cold Length",
          flex: 2,
          minWidth: 85,
        },
        {
          field: "HotLength",
          headerName: "Hot Length",
          flex: 2,
          minWidth: 80,
        },
        {
          field: "WeightRounded",
          colId: "WeightRounded",
          headerName: "Weight Rounded",
          flex: 2,
          minWidth: 120,
          valueFormatter: (params) =>
            (params.data as Torch).WeightRounded
              ? (params.data as Torch).WeightRounded?.toFixed(0) || ""
              : "",
        },
        {
          field: "WeightOriginal",
          colId: "WeightOriginal",
          headerName: "Weight Original",
          flex: 2,
          minWidth: 120,
          valueFormatter: (params) =>
            (params.data as Torch).WeightOriginal
              ? (params.data as Torch).WeightOriginal?.toFixed(2) || ""
              : "",
        },
        {
          field: "TotalCuts",
          colId: "TotalCuts",
          headerName: "#Cuts",
          flex: 2,
          minWidth: 80,
        },
        {
          field: "Undefined",
          colId: "Undefined",
          headerName: "#Unidentified",
          flex: 2,
          minWidth: 95,
        },
        {
          field: "Scrapped",
          colId: "Scrapped",
          headerName: "#Scrapped",
          flex: 2,
          minWidth: 80,
        },
        {
          colId: "Billets",
          valueGetter: (params: ValueGetterParams) => {
            const torch = params.data as Torch;
            return (
              (torch.TotalCuts || 0) -
              (torch.Scrapped || 0) -
              (torch.Undefined || 0)
            );
          },
          headerName: "#Billets",
          flex: 2,
          minWidth: 80,
        },
      ],
    },
  ];

  return { columns };
};
